import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Button } from 'react-bootstrap'
import { client } from '@Utils'
import { Pagination } from '@CommonComponents'

export const App = ({ userId }) => {
  const [currentLogs, setCurrentLogs] = useState([])
  const [paginationRate, setPaginationRate] = useState(20)
  const [totalLogs, setTotalLogs] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const [noLogs, setNoLogs] = useState(false)

  useEffect(() => {
    const fetchLogs = async () => {
      try {
        let resp = await client.get(
          `/account/support_dashboard.get_lti13_logs/-/${userId}?page_num=${currentPage}&page_rate=${paginationRate}`
        )
        setPaginationRate(resp.data.pagRate)
        setTotalLogs(resp.data.total)
        setCurrentLogs(resp.data.logs)
      } catch (err) {
        console.error(err.message)
        setNoLogs(true)
      }
    }
    fetchLogs()
  }, [currentPage])

  return (
    <div>
      {noLogs ? (
        <h4 className="text-center">
          There are no logs to display or there was an error trying to fetch
          them.
        </h4>
      ) : (
        <React.Fragment>
          <Pagination
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            rate={paginationRate}
            total={totalLogs}
          />
          <table className="table table-striped table-hover table-condensed">
            <thead>
              <tr>
                <th>Launch Time (UTC)</th>
                <th>Log ID</th>
                <th>View</th>
              </tr>
            </thead>
            <tbody>
              {currentLogs.map(log => (
                <tr key={`${log.id}`}>
                  <td>{log.time}</td>
                  <td>{log.id}</td>
                  <td>
                    <a
                      href={log.href ? log.href : ''}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Button className="btn btn-default btn-myed btn-default-myed btn-sm-myed">
                        View <i className="fal fa-external-link ml-2" />
                      </Button>
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <Pagination
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            rate={paginationRate}
            total={totalLogs}
          />
        </React.Fragment>
      )}
    </div>
  )
}

App.propTypes = {
  userId: PropTypes.string,
}
